SevenroomsWidget.init({
  venueId: "faithinstrangers",
  triggerId: "sr-res-root", // id of the dom element that will trigger this widget
  type: "reservations", // either 'reservations' or 'waitlist' or 'events'
  styleButton: false, // true if you are using the SevenRooms button
  clientToken: "", //(Optional) Pass the api generated clientTokenId here
})
